import { collection, getDocs, query, where } from "firebase/firestore";
import React from "react";
import { db } from "../../firebase";

const GetAllStudents = async () => {
  try {
    const UsersDocument = collection(db, "Users");
    let SchoolID = localStorage.getItem("schoolId");
    SchoolID = JSON.parse(SchoolID);

    if (SchoolID) {
      const q = query(
        UsersDocument,
        where("UserType", "==", "student"),
        where("SchoolID", "==", SchoolID)
      );

      const UsersSnapshot = await getDocs(q);

      let Students = [];

      UsersSnapshot.forEach((doc) => {
        Students.push({ ...doc.data(), id: doc.id });
      });

      return Students;
    }
  } catch (error) {
    console.log(error);
  }
};

export default GetAllStudents;
